$('.input-container span').on('click', function(){
    if($(this).attr('data-state') == 'view'){
        $(this).attr('data-state', 'hide');
        $(this).html($(this).attr('data-hide'));
        $(this).closest('.input-container').find('input').attr('type', 'text');
    }
    else{
        $(this).attr('data-state', 'view');
        $(this).html($(this).attr('data-view'));
        $(this).closest('.input-container').find('input').attr('type', 'password');
    }
});

$('.input-container img').on('click', function(){
    $(this).closest('.input-container').find('input').focus();
    if($(this).closest('.input-container').parent().hasClass('edit-pass')){
        $(this).closest('.input-container').parent().find('.input-container').fadeIn(500);
    }
});

$('.reorder-search-form').on('submit', function(e){
    e.preventDefault();
    $('.woocommerce-reorder-table td.product a').each(function(){
        if($(this).html().toLocaleLowerCase().indexOf($('.reorder-search-form input').val().toLocaleLowerCase()) > -1){
            $(this).closest('tr').fadeIn(500);
        }
        else{
            $(this).closest('tr').fadeOut(500);
        }
    })
});

$('.woocommerce-reorder-table .added-to-cart .close').on('click', function(e){
    e.preventDefault();
    $(this).closest('.added-to-cart').fadeOut(500);
});

if($('.woocommerce-orders-table').length > 0){
    if($('.woocommerce-orders-table').attr('data-search') != ''){
        $('.woocommerce-orders-table__row').each(function(){
            if($(this).attr('id').indexOf($('.woocommerce-orders-table').attr('data-search')) > -1){
                $(this).fadeIn(500);
            }
            else{
                $(this).fadeOut(500);
            }
        })
    }
}